import { isIphoneDevice } from "core/utils/utils.helper";
import { getUserAgentDetails } from "helpers/userAgent";
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
  Messaging,
} from "firebase/messaging";
import { saveFirebasetoken } from "services/profile.services";

// Firebase configuration object
const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const initializeMessaging = async (): Promise<Messaging | null> => {
  const supported = await isSupported();
  if (supported) {
    return getMessaging(app);
  } else {
    console.warn("FCM is not supported in this browser.");
    return null;
  }
};
const messagingPromise = initializeMessaging();

// Function to request the FCM token
export const requestForToken = async (
  userId: any,
  deviceInfo: any,
): Promise<{ fcmToken: string | null }> => {
  const messaging = await messagingPromise;
  if (!messaging) return { fcmToken: null };

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_VAPID_KEY,
    });
    if (currentToken) {
      const userDetails = getUserAgentDetails();
      const payload = {
        userId: userId,
        fcmToken: currentToken,
        deviceInfo: deviceInfo,
        is_standalone: isIphoneDevice(userDetails?.device?.model),
      };
      await saveFirebasetoken(payload);

      return { fcmToken: currentToken };
    } else {
      console.log("No registration token available.");
      return { fcmToken: null };
    }
  } catch (err) {
    console.error("An error occurred while retrieving token. ", err);
    return { fcmToken: null };
  }
};
// Function to handle incoming messages
export const onMessageListener = (): Promise<unknown> =>
  new Promise((resolve) => {
    messagingPromise.then((messaging) => {
      if (messaging) {
        onMessage(messaging, (payload) => {
          resolve(payload);
        });
      }
    });
  });
